export function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
export function getUrlParams(keyArr) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const res = {}
  keyArr.forEach(key => {
    const value = urlParams.get(key)
    if (value) res[key] = value
  });
  return res
}

export function transformQueryString(q) {
  let textStr = Object.keys(q).filter((i) => !!q[i]).map((key) => `${key}=${q[key]}`).join('&')
  textStr = (textStr) ? `?${textStr}` : ''
  return textStr
}


export function getTrans(objArr, lang, field = null) {
  return objArr.filter(i => (i.language === lang && (!field || i.ref_field === field)))[0]?.content || ''
}
export const asyncSelectStyles = {
  menu: provided => ({ ...provided, zIndex: 9999 }),
  control: (base, state) => {
    return {
      ...base,
      '&:hover': { borderColor: 'unset', }, // border style on hover
      boxShadow: 'none', // no box-shadow
    }
  }
}
export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getDomain(lang) {
  return `${window.location.origin}${(lang !== 'th') ? `/${lang}` : ''}`
}

export function getDefaultRoute(user) {
  if (!user) return '/sigin'

  const { role } = user
  if (role === 'admin') {
    return '/dashboard'
  } else if ( role === 'marketing') {
    return '/dashboard/blogs'
  } else {
    return '/dashboard/properties'
  }

}